import React from "react"
import { Table } from "components/common/marketing/vouchers"

export default () => {
  return <Table status="Scheduled" />
}
